<template>
  <div class="box" v-if="type === 2">
    <div class="box-item" v-for="item in messageList" :key="item.userInfo.id">
        <div class="item-img" style="cursor: pointer;" @click="handleClick(item.type,item.userInfo.id)">
            <img v-lazy="$global.imgUrl + item.userInfo.headPhoto" alt="" v-if="item.userInfo.headPhoto"/>
            <span v-else>
              <Big width='64' height='64' size='20' :big ='item.userInfo.name'/>
            </span>
        </div>
        <div class="item-content">
          <div class="content-name">
              <p class="name-box" style="cursor: pointer;" @click="handleClick(item.type,item.userInfo.id)">{{item.userInfo.name}}</p>
              <p class="title-box">
                  <span style="margin-right: 5px;" v-for="i in item.userInfo.title" :key="i.id">{{i.levelThreeName}}</span>
              </p>
          </div>
          <div class="content-unit">{{item.userInfo.unit}}</div>
          <div class="content-field">
            <span>研究领域：</span>
            <span style="margin-right: 5px;" v-for="i in item.userInfo.subject" :key="i.id">
              {{i.levelTwoName}}
            </span>
          </div>
        </div>
    </div>
  </div>
  <div class="box" v-else-if="type === 4">
    <div class="box-item" v-for="(item,index) in messageList" :key="index">
      <div class="item-img" style="cursor: pointer;" @click="handleClick(item.type,item.prd.id)">
        <img v-if="item.prd.periodicalLogo" v-lazy="$global.imgUrl + item.prd.periodicalLogo" alt=""/>
        <img
          :src="require('@/assets/img/details/qikan.png')"
          alt=""
          v-else
        />
      </div>
      <div class="item-content">
        <p class="name-box" style="cursor: pointer;" @click="handleClick(item.type,item.prd.id)">{{item.prd.name}}</p>
        <div class="content-unit" v-if="item.prd.organizerList && item.prd.organizerList.length > 0">
          <span>主办单位：</span>
            <span
              style="margin-right: 5px;"
              v-for="i in item.prd.organizerList"
              :key="i.orgId">
              {{i.orgName}}
            </span>
        </div>
        <div class="content-unit" v-else>
          <span>主办单位：</span>
          <span style="margin-right: 5px;">{{item.prd.responsibleDept}}</span>
        </div>
        <div class="content-unit">
          <span>出版周期：</span>
          <span style="margin-right: 5px;">{{ item.prd.publishPeriod | period }}</span>
        </div>
        <div class="content-unit">
          <span>CN：</span>
          <span style="margin-right: 10px;">{{ item.prd.cn }}</span>
          <span>ISSN：</span>
          <span>{{ item.prd.issn }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="box" v-else-if="type === 5">
    <div class="box-item" v-for="item in messageList" :key="item.org.id">
      <div class="item-img" style="cursor: pointer;" @click="handleClick(item.type,item.org.id)">
        <img v-if="item.org.coverImg" v-lazy="$global.imgUrl + item.org.coverImg" alt="" />
        <img
          :src="require('@/assets/img/details/jigou.png')"
          alt=""
          v-else
        />
      </div>
      <div class="item-content">
        <p class="name-box" style="cursor: pointer;" @click="handleClick(item.type,item.org.id)">{{item.org.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messageList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
    }
  },
  filters: {
    period(num) {
      if (num == 1) {
        return `年刊`;
      } else if (num == 2) {
        return `半年刊`;
      } else if (num == 3) {
        return `季刊`;
      } else if (num == 4) {
        return `双月刊`;
      } else if (num == 5) {
        return `月刊`;
      } else if (num == 6) {
        return `半月刊`;
      } else if (num == 7) {
        return `旬刊`;
      } else if (num == 8) {
        return `周刊`;
      } else if (num == 9) {
        return `周二刊`;
      } else {
        return `nan`;
      }
      // 1 年刊 2半年刊 3 季刊 4 双月刊 5 月刊 6 半月刊 7 旬刊 8 周刊 9 周二刊
    },
  },
  methods: {
    handleClick(type,id) {
      let routeUrl;
      if (type === 2) {
        routeUrl = this.$router.resolve({
          name: "bjzxdetail",
          query: {
            title: "百家在线",
            id,
          },
        });
      } else if (type === 4) {
        routeUrl = this.$router.resolve({
          name: "bkzxdetail",
          query: {
            title: "百科在线",
            id,
          },
        });
      } else if (type === 5) {
        routeUrl = this.$router.resolve({
          name: "jghdetail",
          query: {
            title: "机构号",
            id,
          },
        });
      }
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
    display: flex;
    flex-wrap: wrap;
    .box-item {
        display: flex;
        padding: 0px 50px 55px;
        width: 600px;
        &:nth-child(2n-1) {
            padding-right: 49px;
            border-right: 1px dotted #DCDCDC; ;
        }
        .item-img {
            width: 64px;
            margin-right: 11px;
            img {
                width: 64px;
                height: 64px;
                border-radius: 32px;
            }
        }
        .item-content {
            width: 425px;
            .content-name {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .name-box {
                  margin-right: 25px;
                }
                .title-box {
                    flex: 1;
                    font-size: 14px;
                    color: #1876F0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .name-box {
              max-width: 125px;
              font-size: 18px;
              font-weight: 900;
              color: #263D78;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .content-unit {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                color: #333;
            }
            .content-field {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 30px;
                font-size: 14px;
                color: #333;
            }
        }
    }
}
</style>
